module.exports = __webpack_public_path__ + "img/icon-group4.291565af.png";